import React from "react";
import "../styles/Services.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import UseSEO from "../../Hooks/useSEO";
import BubbleBackground from "../common/BubbleBackground";
import usePauseOnOutOfView from "../../Hooks/usePauseOnOutOfView";
import {
    ShieldCheck,
    HeartPulse,
    Car,
    Laptop,
    Wrench,
    Camera,
    Sun,
    Droplets,
    BatteryCharging
} from "lucide-react";

const Services = () => {

     // Use the hook at the top of the component suport in React 19

    UseSEO({
        title: "Sujaramaha Enterprises | Our Services | Computer & Printers Sales & Services, CCTV,All types of Insurance, Water Filter / RO System & Kitchen Chimneys, Solar Water Heater, Inverter & Battery",
        description:
            "Sujaramaha Enterprises provides computer & Printers sales and services, All types of insurance assistance, CCTV installation, Water Filter / RO System & Kitchen Chimneys, Solar Water Heater, Inverter & Battery with trusted local support.",
        keywords:
            "computer sales and services, Printer sales and services, All types of insurance assistance, CCTV installation, Water Filter / RO System & Kitchen Chimneys, Solar Water Heater, Inverter & Battery, Sujaramaha Enterprises"
    });

    const sectionRef = usePauseOnOutOfView();

    return (
        <div className="services-page">

            {/* Hero */}
            <section className="services-hero">
                <div className="services-hero-overlay">
                    <h1>Our Services</h1>
                    <p>
                        Comprehensive Insurance, Technology & Security Solutions
                        under one trusted brand - Sujaramaha Enterprises
                    </p>
                </div>
            </section>

            {/* Services Grid */}
            <section ref={sectionRef} className="services-container">
                <BubbleBackground />
                <h2>What We Offer</h2>

                <div className="services-grid">

                    <div className="service-card">
                        <ShieldCheck />
                        <h3>Insurance Services</h3>
                        <p>
                            We provide reliable insurance solutions in India, offering Vehicle Insurance,
                            Health Insurance, Travel Insurance, and SME Insurance.
                            Our services include professional claim assistance, transparent guidance,
                            and policies from trusted insurance providers to secure your future.
                        </p>
                        
                    </div>

                    <div className="service-card">
                        <Car />
                        <h3>Vehicle Insurance</h3>
                        <p>
                            Get reliable two-wheeler, four-wheeler, and commercial vehicle insurance with instant online renewal,
                            comprehensive coverage, cashless claim support, and affordable premium options from
                            top insurance companies in India.
                        </p>
                    </div>

                    <div className="service-card">
                        <HeartPulse />
                        <h3>Health Insurance</h3>
                        <p>
                            Affordable health insurance plans for individuals and families with comprehensive coverage,
                            cashless treatment across a wide hospital network, and reliable claim support from trusted insurers.
                        </p>
                    </div>

                    <div className="service-card">
                        <Laptop />
                        <h3>Computer Sales</h3>
                        <p>
                            Branded laptops, desktops, computer accessories, and IT products for home and business use,
                            offering reliable performance, genuine products, and competitive pricing.
                        </p>
                    </div>

                    <div className="service-card">
                        <Wrench />
                        <h3>Computer Service & Repair</h3>
                        <p>
                            Professional computer repair and maintenance services including hardware troubleshooting,
                            software installation, system upgrades, virus removal, and annual maintenance contract (AMC) services.
                        </p>
                    </div>

                    <div className="service-card">
                        <Camera />
                        <h3>CCTV Sales & Service</h3>
                        <p>
                            Complete CCTV camera sales and service solutions including supply, professional installation,
                            maintenance, and 24/7 surveillance support for homes, offices, and commercial premises.
                        </p>
                    </div>

                    <div className="service-card">
                        <Sun />
                        <h3>Solar Water Heater</h3>
                        <p>
                            Energy-efficient solar water heater systems for residential and commercial use,
                            offering eco-friendly hot water solutions, professional installation, and reliable performance.
                        </p>
                    </div>

                    <div className="service-card">
                        <Droplets />
                        <h3>Water Filter / RO System & Kitchen Chimneys</h3>
                        <p>
                            Sales and service of RO, UV, and UF water purifier systems ensuring safe,
                            clean drinking water with professional installation and maintenance support.
                        </p>
                    </div>

                    <div className="service-card">
                        <BatteryCharging />
                        <h3>Inverter & Battery</h3>
                        <p>
                            Reliable inverter and battery solutions for home, office, and commercial needs,
                            offering power backup systems, professional installation, and dependable performance.
                        </p>
                    </div>


                </div>
            </section>

            {/* CTA */}
            <section className="services-cta">
                <h2>Need Expert Assistance?</h2>
                <p>
                    Contact Sujaramaha Enterprises today for trusted services,
                    professional support, and reliable solutions tailored to your needs.
                </p>
                <a href="/contact">Contact Us</a>
            </section>

        </div>
    );
};

export default Services;
